import { useTranslation } from "react-i18next";
import Directions from "../../home/directions/Directions";

const MagistraturaDirections = () => {
  const { t } = useTranslation();
  return <Directions titleOverride={t("magistratura_yonalishlari")} endpoint={"/api/directions/masters/"} filterLevel={"master"} />;
};

export default MagistraturaDirections; 